/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersProfileBalanceMutationRequest, PostUsersProfileBalanceMutationResponse, PostUsersProfileBalance400 } from "../entities/PostUsersProfileBalance";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postUsersProfileBalance } from "../api/postUsersProfileBalance";
import { useMutation } from "@tanstack/react-query";

export const postUsersProfileBalanceMutationKey = () => [{ url: '/users/profile/balance' }] as const

export type PostUsersProfileBalanceMutationKey = ReturnType<typeof postUsersProfileBalanceMutationKey>

/**
 * @description Пополнение баланса
 * @summary Пополнение баланса
 * {@link /users/profile/balance}
 */
export function usePostUsersProfileBalance<TContext>(options: 
{
  mutation?: UseMutationOptions<PostUsersProfileBalanceMutationResponse, ResponseErrorConfig<PostUsersProfileBalance400>, {data: PostUsersProfileBalanceMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostUsersProfileBalanceMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postUsersProfileBalanceMutationKey()

  return useMutation<PostUsersProfileBalanceMutationResponse, ResponseErrorConfig<PostUsersProfileBalance400>, {data: PostUsersProfileBalanceMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return postUsersProfileBalance(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}